// Styles
import './Card.css'

const Card = ({ title, description, onEdit, onDelete, onDragStart }) => {
  return (
    <div
      className='Card'
      draggable
      onDragStart={onDragStart}
    >
      <div className='Card-header'>
        <span className='Card-title'>{title}</span>
        <div className='Card-actions'>
          <button className='Card-edit-btn' onClick={onEdit}>✏️</button>
          <button className='Card-delete-btn' onClick={onDelete}>🗑️</button>
        </div>
      </div>
      <p className='Card-description'>{description}</p>
    </div>
  )
}

export default Card